// API Link
export default {endpoint : process.env.REACT_APP_API_ENDPOINT };


// WEBPACK FOOTER //
// ./src/config.js
